import { render, staticRenderFns } from "./AdminTeamStats.vue?vue&type=template&id=2b20113a"
import script from "./AdminTeamStats.vue?vue&type=script&lang=ts"
export * from "./AdminTeamStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports